import { SelectItem } from '@/constants/static';

export default {
  data(): any {
    return {
      possibleDurationTimes: [
        { value: 10, text: this.$t('minutes', { minutes: '10' }).toString() },
        { value: 15, text: this.$t('minutes', { minutes: '15' }).toString() },
        { value: 20, text: this.$t('minutes', { minutes: '20' }).toString() },
        { value: 30, text: this.$t('minutes', { minutes: '30' }).toString() },
        { value: 45, text: this.$t('minutes', { minutes: '45' }).toString() },
        { value: 60, text: this.$t('hours', { hours: '1' }).toString() },
        { value: 90, text: this.$t('hoursAndAHalf', { hours: '1' }).toString() },
        { value: 120, text: this.$t('hours', { hours: '2' }).toString() },
        { value: 180, text: this.$t('hours', { hours: '3' }).toString() },
        { value: 240, text: this.$t('hours', { hours: '4' }).toString() }
      ],
      possibleWeekDays: [
        { value: 6, text: this.$tc('saturday') },
        { value: 0, text: this.$tc('sunday') },
        { value: 1, text: this.$tc('monday') },
        { value: 2, text: this.$tc('tuesday') },
        { value: 3, text: this.$tc('wednesday') },
        { value: 4, text: this.$tc('thursday') },
        { value: 5, text: this.$tc('friday') }
      ],
      possiblePaddingTimes: [
        { value: 0, text: this.$t('minutes', { minutes: '0' }).toString() },
        { value: 5, text: this.$t('minutes', { minutes: '5' }).toString() },
        { value: 10, text: this.$t('minutes', { minutes: '10' }).toString() },
        { value: 15, text: this.$t('minutes', { minutes: '15' }).toString() },
        { value: 20, text: this.$t('minutes', { minutes: '20' }).toString() },
        { value: 30, text: this.$t('minutes', { minutes: '30' }).toString() },
        { value: 45, text: this.$t('minutes', { minutes: '45' }).toString() },
        { value: 60, text: this.$t('hours', { hours: '1' }).toString() },
        { value: 90, text: this.$t('hoursAndAHalf', { hours: '1' }).toString() },
        { value: 120, text: this.$t('hours', { hours: '2' }).toString() },
        { value: 180, text: this.$t('hours', { hours: '3' }).toString() },
        { value: 240, text: this.$t('hours', { hours: '4' }).toString() }
      ]
    };
  },
  methods: {
    getDurationTime(time: number): string {
      const _this = this as any;

      const index = _this.possibleDurationTimes.findIndex((el: SelectItem) => el.value === time);
      if (index > -1) {
        return _this.possibleDurationTimes[index].text;
      }

      return _this.possibleDurationTimes[0].text;
    }
  }
} as any;
